<template>
  <div class="index-page ">
    <div class="modal">
      <!--未登录-->
      <div class="top-user-info flex-center" v-if="!isLogin">
        <img :src="bannerUrl1" alt="">
        <div>
          <div class="desc">{{ $t('index.label1') }}</div>
          <Button class="btn small" @click.stop="toLogin">{{ $t('index.label2') }}</Button>
        </div>
      </div>
      <!--已登录未认证-->
      <div class="top-user-info flex-center" v-if="isLogin && authStatus != 2">
        <img :src="bannerUrl2" alt="">
        <div>
          <div class="desc" v-if="authStatus == 1">{{ $t('index.label3') }}</div>
          <div class="desc" v-else>{{ $t('index.label4') }}</div>
          <Button class="btn" :disabled="authStatus == 1" @click="toPath('userAuth')">{{ $t('index.label5') }}</Button>
        </div>
      </div>
      <!--已认证-->
      <div class="top-user-info flex-center" v-if="isLogin && authStatus == 2">
        <img :src="bannerUrl3" alt="">
        <div>
          <div class="desc clickable" @click="toRewardDetail">{{ $t('index.label6') }}</div>
          <div class="flex-center-start">
            <Button class="btn gray small" @click="toPath('withdraw')">{{ $t('assestLog.label2') }}</Button>
            <Button class="btn small" @click="toPath('recharge')">{{ $t('assestLog.label1') }}</Button>
          </div>
        </div>
      </div>


      <div class="recommend-list flex-center-between">
        <div class="recommend " v-for="(item, i) in recommendList" :key="i">
          <div class="flex-center-between">
            <div class="name">
              <span class="black">{{item.ShortName}}</span>/USDT
            </div>
            <div class="icon">
              <img :src="`/upload/${item.Logo}`" alt="">
            </div>
          </div>
          <div class="count" :class="item.percent >= 0 ? 'green' : 'red'">
            {{item.count || 0}}
            <span class="small">≈ {{item.count}}</span>
          </div>
          <div class="percent" :class="item.percent >= 0 ? 'green' : 'red'">
            {{item.percent >= 0 ? '+' : ''}}{{item.percent}}%
          </div>
        </div>
      </div>



      <div class="rank-title flex">
        <div class="title" v-for="(item, i) in rankType" :key="i" :class="rankIndex == i ? 'active' : ''" @click="changeRank(i)">{{item}}</div>
      </div>

      <div class="rankList">
        <div class="table-th flex-center">
          <div class="th flex-3">{{ $t('transfer.label3') }}</div>
          <div class="th flex-2 text-center">{{ $t('index.label10') }}</div>
          <div class="th flex-2 text-center">{{ $t('zhang-die-fu') }}</div>
          <div class="th flex-3 text-center">{{ $t('qu-shi-tu') }}</div>
          <div class="th action text-center">{{ $t('cao-zuo-1') }}</div>
        </div>
        <bit-page :dataList="rankList" @detail="toDetail"></bit-page>
      </div>
    </div>
  </div>
</template>

<script>
import { getCoinList, quoteList, getNoticeList } from '@/api/index'
import { checkAuth } from '@/api/setting'
import { userInfo } from '@/api/user'
import { Button, Swipe, SwipeItem, Popup, NoticeBar  } from 'vant'
import moment from 'moment'
import bitPage from '@/components/bit'
import {initWebSocket, sortByField} from '@/utils/common'
import { setUser, setUserAvatar, setUserEmail, setUserId, getToken,setRemark } from '@/utils/auth'
import { customerList } from '@/api/setting'
import "@/utils/sdk.js"
export default {
  name: 'about',
  components: {
    Button,
    Swipe,
    SwipeItem,
    Popup,
    bitPage,
    NoticeBar
  },
  data() {
    return {
      authStatus: 0,
      webSocket: '',
      avatar: '',
      noticeMsg: '',
      // bannerUrl1: require('../../assets/imgs/banner1.png'),
      bannerUrl1: require('../../assets/imgs/banner1.png'),
      bannerUrl2: require('../../assets/imgs/banner1.png'),
      bannerUrl3: require('../../assets/imgs/banner1.png'),
      showRecharge: false,
      rechargeIndex: -1,
      rechargeName: '',
      recommendList: [],
      rankType: [
        this.$t('index.rank1'),
        this.$t('zhang-fu-bang'),
        this.$t('index.rank3'),
      ],
      rankIndex: 1,
      rankListBak: [],
      rankList: [  ],
      bitListBak: [],
      quoteListBak: [],
      showKefu: false,
      kefuList: [],
      isLogin: false,
      userAuth: false,
      tabBitList1: [], // 主流币
      tabBitList3: [], // 热门币
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    },
    isSend() {
      return this.$store.state.isSend
    },
    bitList() {
      return this.$store.state.bitList
    },
    showWelcome() {
      return this.$store.state.showWelcome
    },
    screenScale() {
      return this.$store.state.screenScale
    },
    loginStatus() {
      return this.$store.state.isLogin
    },
  },
  watch: {
    loginStatus() {
      if (getToken()) {
        this.isLogin = true
        this.initStatus()
      } else {
        this.isLogin = false
      }
    }
  },
  mounted() {
    if (getToken()) {
      this.isLogin = true
      this.initStatus()
    }
    this.init()
    this.initSocket()


  },
  beforeDestroy() {
    this.$store.state.isSend = false
    if (this.webSocket && this.webSocket.close) {
      this.$store.state.isClose = true
      this.webSocket.close()
    }
  },
  methods: {
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    init() {
      //币种列表
      let list = localStorage.getItem('bitList')
      if (list && list != 'undefined' && this.bitList.length == 0) {
        this.$store.state.bitList = JSON.parse(list)
      }
      if (this.bitList.length > 0) {
        this.rankListBak = [].concat(this.bitList)
        // 涨幅榜按涨幅排序，其他按order等字段排序
        this.rankList = this.rankListBak.filter(v => {
          return v.HomeShow == 1
        }).sort((a, b) => {
          return Math.abs(b.percent) - Math.abs(a.percent)
        }).slice(0, 8)
        this.recommendList = this.rankList.filter(v => {
          return v.IsRecommend == 1
        }).sort((a, b) => {
          return a.Order - b.Order
        }).slice(0, 3)

        this.recommendList = sortByField(this.recommendList, 'Order',"asc")
      }

      getCoinList().then(res => {
        this.bitListBak = res.data.Items.map(v => {
          v.percent = 0
          return v
        })
        this.rankListBak = res.data.Items.map(v => {
          v.percent = 0
          return v
        })
        this.changeRank(this.rankIndex)
        // this.rankList = this.rankListBak.filter(v => {
        //   return v.HomeShow == 1
        // }).sort((a, b) => {
        //   return a.HomeOrder - b.HomeOrder
        // }).slice(0, 8)

        this.recommendList = this.rankListBak.filter(v => {
          return v.IsRecommend == 1
        }).sort((a, b) => {
          return a.Order - b.Order
        }).slice(0, 3)
        this.recommendList = sortByField(this.recommendList, 'Order',"asc")
        this.$store.state.bitList = [].concat(this.bitListBak)
        localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
      })


      //用户信息
      if (getToken()) {
        userInfo().then(res => {
          let data = res.data
          setUser(data.Email || data.Phone || '')
          setUserEmail(data.Email)
          setUserId(data.ID)
          setRemark(data.Remark)
          this.$store.state.shareCode = data.InviteCode
        })
      } else {
        this.avatar = ''
      }


    },
    initStatus() {
       // 用户认证状态
      checkAuth().then(res => {
        this.authStatus = res.data.status
      })
    },
    async initSocket(){ //初始化weosocket
      let client = await initWebSocket('all', this.websocketonmessage)
      this.webSocket = client.ws
    },
    websocketonmessage(e){ //数据接收
      let data = e.data
      let redata = {}
      try {
        redata = JSON.parse(e.data)
        this.setListData(redata)
      }
      catch(e) {
      }
    },
    setListData(data) {
      let index = this.rankListBak.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let recommendIndex = this.recommendList.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let bitIndex = this.bitListBak.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let valObj = data.fields
      let percent = parseFloat(((valObj.Close - valObj.Yesterday) / valObj.Yesterday * 100).toFixed(2))
      if (index > -1) {
        this.rankListBak[index] = {
          ...this.rankListBak[index],
          ...valObj,
          percent,
          count: valObj.Close,
        }
        this.bitListBak[bitIndex] = {
          ...this.bitListBak[bitIndex],
          ...valObj,
          percent,
          count: valObj.Close,
        }
        this.$store.state.bitList = [].concat(this.bitListBak)
        localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
      }

      if (recommendIndex > -1) {
        this.recommendList[recommendIndex] = {
          ...this.recommendList[recommendIndex],
          ...valObj,
          percent,
          count: valObj.Close,
        }
      }


      if (this.rankIndex == 0) {
        this.rankList = this.rankListBak.filter(v => {
          return v.IsMain == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.MainOrder - b.MainOrder
        })
      } else if (this.rankIndex == 1) {
        this.rankList = this.rankListBak.filter(v => {
          return v.HomeShow == 1
        }).sort((a, b) => {
          return Math.abs(b.percent) - Math.abs(a.percent)
        }).slice(0, 8)
      } else if (this.rankIndex == 2) {
         this.rankList = this.rankListBak.filter(v => {
          return v.IsHot == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.HotOrder - b.HotOrder
        })
      }


      this.recommendList = this.rankListBak.filter(v => {
        return v.IsRecommend == 1
      }).sort((a, b) => {
        return a.Order - b.Order
      }).slice(0, 3)
    },
    toDetail(data) {
      this.$router.push({
        name: 'trade',
        query: {
          name: data.ShortName,
          id: data.ID,
          type: 2
        }
      })
    },
    toLogin() {
      this.$router.push({ name: 'login', query: { redirect: this.$route.fullPath } })
    },
    toRegister() {

    },
    toRewardDetail() {
      this.$router.push({ name: 'rewardDetail' })
    },
    changeRank(i) {
      this.rankIndex = i
      if (i == 0) {
        this.rankList = this.rankListBak.filter(v => {
          return v.IsMain == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.MainOrder - b.MainOrder
        })
      } else if (i == 1) {
        this.rankList = this.rankListBak.filter(v => {
          return v.HomeShow == 1
        }).sort((a, b) => {
          return Math.abs(b.percent) - Math.abs(a.percent)
        }).slice(0, 8)
      } else if (i == 2) {
         this.rankList = this.rankListBak.filter(v => {
          return v.IsHot == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.HotOrder - b.HotOrder
        })
      }
    }
  },
}
</script>
<style lang="less">
.desc.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: 8px 12px;

  &:hover {
    background: rgba(255, 215, 0, 0.1);
    color: #FFD700;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
